const partners = [
  {
    slug: 'partner-one',
    name: 'Partner One',
    description: 'Innovating sustainable mobility',
    tagline: 'Your trusted partner in innovation.',
    bio: 'Partner One is a seasoned technology partner dedicated to guiding organizations through every step of their digital transformation journey. With over a decade of experience, we design and deliver bespoke solutions that span enterprise cloud migrations, AI-driven analytics platforms, and robust cybersecurity frameworks. Our multidisciplinary teams—comprised of software architects, data scientists, and process engineers—collaborate closely with clients to understand unique business challenges and craft scalable, future-proof systems. From automating mission-critical workflows to deploying intuitive customer-facing applications, we leverage agile methodologies and industry best practices to accelerate time-to-value and drive measurable ROI. Committed to continuous innovation, Partner One invests heavily in research partnerships and in-house R&D, ensuring our clients benefit from the latest advances in machine learning, IoT integration, and low-code development. Whether you’re a fast-growing startup or a global enterprise, we provide the strategic vision and technical expertise required to turn disruption into competitive advantage.',
    image: '/assets/images/partner1.jpg', // Make sure this image exists in public/assets/images
    email: 'info@partnerone.com',
    website: 'https://partnerone.com',
    phone: '+1 234 567 8900',
    link: '/partners/partner-one'
  },
  {
    slug: 'partner-two',
    name: 'Partner Two',
    description: 'AI-powered analytics',
    tagline: 'Empowering businesses worldwide.',
    bio: 'Partner Two provides strategic consulting services for enterprises seeking global expansion.',
    image: '/assets/images/partner2.jpg',
    email: 'contact@partnertwo.com',
    website: 'https://partnertwo.com',
    link: '/partners/partner-two'
  },
  {
    name: 'Partner Three',
    tagline: 'AI-driven transformation powerhouse.',
    description: 'Human-centered design firm',
    image: '/assets/images/partner3.jpg',
    slug: 'partner-three',
    bio: 'Partner One is a global leader in innovation and consulting...',
    email: 'contact@partnerone.com',
    website: 'https://partnerone.com',
    phone: '+1234567890',
    link: '/partners/partner-three'

  },
  {
    name: 'Partner Four',
    tagline: 'Shaping the future of urban strategy.',
    description: 'Next-gen IoT infrastructure',
    image: '/assets/images/partner4.jpg',
    slug: 'partner-four',
    bio: 'Partner One is a global leader in innovation and consulting...',
    email: 'contact@partnerone.com',
    website: 'https://partnerone.com',
    phone: '+1234567890',
    link: '/partners/partner-four'
  },
];

export default partners;
